const mutations = {
  getCxReports: (state, report) => {
    state.report = report;
  },
  getClaimReason: (state, reason) => {
    state.reason = reason;
  },
  getClaimRejectReason: (state, rejectReason) => {
    state.rejectReason = rejectReason;
  },
  getClaimAdminHub: (state, adminHub) => {
    state.adminHub = adminHub;
  },
  getCxReport: (state, report_id) => {
    state.report_id = report_id;
  },
  postCxComment: (state, payload) => {
    state.report_id.comments.push({
      name: payload.commentData.user_id, date_comment: payload.commentData.date_comment, comment: payload.commentData.comment_internal, type_comment: 'Internal',
    }, {
      name: payload.commentData.user_id, date_comment: payload.commentData.date_comment, comment: payload.commentData.comment_external, type_comment: 'External',
    });
  },
  putCxStatus: (state, payload) => {
    state.report = state.report.tickets.map((report) => {
      if (report.id === payload.id) {
        return Object.assign({}, report, payload.statusData.status);
      }
      return report;
    });
  },
};

export default mutations;
